<template>
  <footer class="footer">
    <div class="container">
      <p>&copy; 2025 Adbc株式会社. All Rights Reserved.</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'LpFooter',
};
</script>

<style scoped>
/* フッター */
.footer {
  background-color: #343a40; /* 暗い背景色 */
  color: #f8f9fa; /* 明るいテキスト色 */
  padding: 3rem 0;
  text-align: center;
  margin-top: 6rem;
}

.footer p {
  font-size: 1.4rem;
}
</style>
